import { grey } from "@mui/material/colors";

const styles = {
  link: {
    textUnderlineOffset: "5px",
  },
  header: { fontSize: { xs: 20, md: 30 } },
  limitedTime: {
    backgroundColor: "transparent",
    color: "secondary.dark",
  },
  plancard: {
    border: `1px solid black`,
    px: 3,
    py: 1,
    color: grey[500],
    borderRadius: 2,
    textTransform: "none",
  },
  selected: {
    background: "white",
    color: "black",
    border: `1px solid black`,
  },
};

export default styles;
